import { getApiClient } from '../apiClient';
import { NOTIFICATION_ENDPOINTS, replacePathParams } from '../endpoints';
import type {
    CreateAdminNotificationPayload,
    AdminNotificationResponse,
    GetAdminNotificationsResponse,
    GetAdminNotificationResponse
} from '../types/notification.types';
import type { PaginationParams, SearchParams } from '../types';

export const notificationService = {
    /**
     * Send notification from admin
     */
    sendAdminNotification: (payload: CreateAdminNotificationPayload): Promise<AdminNotificationResponse> => {
        return getApiClient().post(NOTIFICATION_ENDPOINTS.createAdminNotification, payload);
    },

    /**
     * Get all admin notifications
     */
    getAdminNotifications: (params?: PaginationParams & SearchParams & { type?: number }): Promise<GetAdminNotificationsResponse> => {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append('page', String(params.page));
        if (params?.limit) queryParams.append('limit', String(params.limit));
        if (params?.search) queryParams.append('search', params.search);
        if (params?.type) queryParams.append('type', String(params.type));

        const url = queryParams.toString()
            ? `${NOTIFICATION_ENDPOINTS.createAdminNotification}?${queryParams.toString()}`
            : NOTIFICATION_ENDPOINTS.createAdminNotification;

        return getApiClient().get(url);
    },

    /**
     * Get single admin notification by ID
     */
    getAdminNotification: (id: string): Promise<GetAdminNotificationResponse> => {
        return getApiClient().get(`${NOTIFICATION_ENDPOINTS.createAdminNotification}/${id}`);
    },

    /**
     * Delete admin notification by ID
     */
    deleteAdminNotification: (id: string): Promise<AdminNotificationResponse> => {
        const url = replacePathParams(NOTIFICATION_ENDPOINTS.deleteAdminNotification, { id });
        return getApiClient().delete(url);
    },
};
